import type { MediaType } from "@/generated/graphql";
import { getMediaConfig } from "../config";

interface EmptyStateProps {
  /** Media type for config lookup */
  mediaType: MediaType;
  /** Whether showing trash view */
  isTrash?: boolean | undefined;
}

/**
 * EmptyState - Empty state message for table
 *
 * Shows appropriate message based on media type and view.
 */
export function EmptyState({ mediaType, isTrash = false }: EmptyStateProps) {
  const config = getMediaConfig(mediaType);
  const message = isTrash ? config.trashEmptyMessage : config.emptyStateMessage;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-12 text-center">
      <p className="text-gray-500">{message}</p>
      {!isTrash && (
        <p className="mt-1 text-sm text-gray-400">
          Upload {config.labelPlural.toLowerCase()} to get started
        </p>
      )}
    </div>
  );
}

export default EmptyState;
